import { useReducer } from 'react';
import { IDS_TOAST_CONTAINER_ID, IDS_TOAST_STORE, toastReducer } from './store';
import { ToasterStoreContext } from './ToasterStoreContext';
import { Toaster } from './Toaster';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ToastProvider = props => {
  const {
    children
  } = props;

  // get the current store and dispatcher for the store
  const [toastStore, dispatch] = useReducer(toastReducer, IDS_TOAST_STORE);

  // wrap in context provider and initialize the ToastViewport
  return /*#__PURE__*/_jsxs(ToasterStoreContext.Provider, {
    value: {
      toastStore,
      dispatch
    },
    children: [/*#__PURE__*/_jsx(Toaster, {
      containerId: IDS_TOAST_CONTAINER_ID
    }), children]
  });
};